/** ************************************************************************
 * Atomic Component for the bPerx iFrame UI.
 *
 * Atomic Type: Content, static (content that never/rarely changes)
 * Purpose: Display "have a gift for you" text of the offer
 *
 * @file   Atomic Component, content static, have a gift text
 * @author Paul J Stales
 * @since  2.2.0
 ************************************************************************ */

import { FunctionalComponent, h } from 'preact'
import { css } from 'aphrodite'
import { IFRAME_CLASSNAMES } from '../../../../../../common/constants/ConstantsIFrameClassNames'

/**
 * Props Interface for OfferGiftText
 */
interface OfferGiftTextProps {
  styles: { [key: string]: any }
  giftText: string
}

/**
 * The single-line text explaining this is a gift.
 * @param OfferGiftTextProps
 * @returns
 */
const OfferGiftText: FunctionalComponent<OfferGiftTextProps> = ({
  styles,
  giftText
}) => {
  return (
    <h4
      class={`${IFRAME_CLASSNAMES.BPERX_OFFER_TITLE_TEXT}${' '}${
        styles[IFRAME_CLASSNAMES.BPERX_OFFER_TITLE_TEXT] === undefined
          ? ''
          : css(styles[IFRAME_CLASSNAMES.BPERX_OFFER_TITLE_TEXT])
      }`}
    >
      {giftText}
    </h4>
  )
}

export default OfferGiftText
